import React from "react";

const FacebookShare = () => {
  return (
    <div className="fb-like fb-button"
      data-href="https://www.facebook.com/fitmykid/"
      data-layout="button"
      data-action="like"
      data-size="large"
      data-show-faces="true"
      data-share="true">
    </div>
  );
};

export default FacebookShare;



/** WEBPACK FOOTER **
 ** ./src/components/FacebookShare.js
 **/